// Contract Filter Options Constants
export const CONTRACT_FILTER_OPTIONS = {
  STATUS: [
    { value: '', label: 'All Statuses' },
    { value: 'open', label: 'Open' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'disputed', label: 'Disputed' },
  ],

  PAYMENT_TYPE: [
    { value: '', label: 'All Types' },
    { value: 'fixed', label: 'Fixed Price' },
    { value: 'hourly', label: 'Hourly Rate' },
  ],

  EXPERTISE_LEVEL: [
    { value: '', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'expert', label: 'Expert' },
  ],
};

// Helper function to create category options from API data
export const createCategoryOptions = (categories) => [
  { value: '', label: 'All Categories' },
  ...categories.map((category) => ({
    value: category.slug || category.name || category,
    label: category.name || category,
  })),
];

// Tech Stack Options List
export const TECH_STACK_OPTIONS = [
  // Frontend Technologies
  { value: 'react', label: 'React' },
  { value: 'vue', label: 'Vue.js' },
  { value: 'angular', label: 'Angular' },
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'html', label: 'HTML' },
  { value: 'css', label: 'CSS' },
  { value: 'sass', label: 'Sass/SCSS' },
  { value: 'tailwind', label: 'Tailwind CSS' },
  { value: 'bootstrap', label: 'Bootstrap' },
  { value: 'jquery', label: 'jQuery' },
  { value: 'nextjs', label: 'Next.js' },
  { value: 'nuxtjs', label: 'Nuxt.js' },
  { value: 'svelte', label: 'Svelte' },

  // Backend Technologies
  { value: 'nodejs', label: 'Node.js' },
  { value: 'python', label: 'Python' },
  { value: 'django', label: 'Django' },
  { value: 'flask', label: 'Flask' },
  { value: 'fastapi', label: 'FastAPI' },
  { value: 'java', label: 'Java' },
  { value: 'spring', label: 'Spring Boot' },
  { value: 'csharp', label: 'C#' },
  { value: 'dotnet', label: '.NET' },
  { value: 'php', label: 'PHP' },
  { value: 'laravel', label: 'Laravel' },
  { value: 'symfony', label: 'Symfony' },
  { value: 'ruby', label: 'Ruby' },
  { value: 'rails', label: 'Ruby on Rails' },
  { value: 'go', label: 'Go' },
  { value: 'rust', label: 'Rust' },
  { value: 'express', label: 'Express.js' },

  // Databases
  { value: 'mysql', label: 'MySQL' },
  { value: 'postgresql', label: 'PostgreSQL' },
  { value: 'mongodb', label: 'MongoDB' },
  { value: 'redis', label: 'Redis' },
  { value: 'sqlite', label: 'SQLite' },
  { value: 'elasticsearch', label: 'Elasticsearch' },
  { value: 'cassandra', label: 'Cassandra' },
  { value: 'dynamodb', label: 'DynamoDB' },

  // Cloud & DevOps
  { value: 'aws', label: 'AWS' },
  { value: 'azure', label: 'Microsoft Azure' },
  { value: 'gcp', label: 'Google Cloud Platform' },
  { value: 'docker', label: 'Docker' },
  { value: 'kubernetes', label: 'Kubernetes' },
  { value: 'jenkins', label: 'Jenkins' },
  { value: 'gitlab-ci', label: 'GitLab CI' },
  { value: 'github-actions', label: 'GitHub Actions' },
  { value: 'terraform', label: 'Terraform' },
  { value: 'ansible', label: 'Ansible' },

  // Mobile Development
  { value: 'react-native', label: 'React Native' },
  { value: 'flutter', label: 'Flutter' },
  { value: 'swift', label: 'Swift' },
  { value: 'kotlin', label: 'Kotlin' },
  { value: 'ionic', label: 'Ionic' },
  { value: 'xamarin', label: 'Xamarin' },

  // Data Science & AI
  { value: 'tensorflow', label: 'TensorFlow' },
  { value: 'pytorch', label: 'PyTorch' },
  { value: 'scikit-learn', label: 'Scikit-learn' },
  { value: 'pandas', label: 'Pandas' },
  { value: 'numpy', label: 'NumPy' },
  { value: 'jupyter', label: 'Jupyter' },
  { value: 'r', label: 'R' },
  { value: 'matlab', label: 'MATLAB' },

  // Testing
  { value: 'jest', label: 'Jest' },
  { value: 'cypress', label: 'Cypress' },
  { value: 'selenium', label: 'Selenium' },
  { value: 'pytest', label: 'PyTest' },
  { value: 'junit', label: 'JUnit' },
  { value: 'mocha', label: 'Mocha' },

  // Tools & Others
  { value: 'git', label: 'Git' },
  { value: 'webpack', label: 'Webpack' },
  { value: 'vite', label: 'Vite' },
  { value: 'babel', label: 'Babel' },
  { value: 'eslint', label: 'ESLint' },
  { value: 'prettier', label: 'Prettier' },
  { value: 'figma', label: 'Figma' },
  { value: 'adobe-xd', label: 'Adobe XD' },
  { value: 'sketch', label: 'Sketch' },
];

// Helper function to create tech stack options from API data
export const createTechStackOptions = (skills) =>
  skills.map((skill) => ({
    value: skill.slug || skill.name || skill,
    label: skill.name || skill,
  }));

// Page configuration
export const PAGE_CONFIG = {
  PAGE_SIZE: 20,
  PAGE_NO: 1,
};

export const CONTRACT_STATUS = {
  ALL: 'all',
  ACTIVE: 'open',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const CONTRACT_FILTER_KEYS = {
  STATUS: 'status',
  PAYMENT_TYPE: 'paymentType',
  CATEGORY: 'category',
  EXPERTISE: 'expertise',
  MIN_AMOUNT: 'minAmount',
  MAX_AMOUNT: 'maxAmount',
  SEARCH: 'search',
  TECH_STACK: 'tech_stack',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

const {
  STATUS,
  PAYMENT_TYPE,
  EXPERTISE,
  MIN_AMOUNT,
  MAX_AMOUNT,
  SEARCH,
  TECH_STACK,
  START_DATE,
  END_DATE,
  CATEGORY,
} = CONTRACT_FILTER_KEYS;

// Default filter values
export const DEFAULT_FILTERS = {
  [STATUS]: '',
  [PAYMENT_TYPE]: '',
  [CATEGORY]: '',
  [EXPERTISE]: '',
  [MIN_AMOUNT]: '',
  [MAX_AMOUNT]: '',
  [SEARCH]: '',
  [TECH_STACK]: [],
  [START_DATE]: '',
  [END_DATE]: '',
};

// Maximum number of profiles that can be selected
export const MAX_SELECT_PROFILE = 5;

// Pagination constants
export const INITIAL_PAGE_SIZE = 8;
export const INITIAL_PAGE = 1;

// Match state constants
export const MATCH_STATE = {
  NEUTRAL: 'neutral',
  SELECTED: 'selected',
  DECLINED: 'declined',
};

// Contract Field Keys - Centralized to avoid hardcoded values
export const CONTRACT_KEYS = {
  // Basic Information
  TITLE: 'title',
  DESCRIPTION: 'description',
  SCOPE: 'scope',

  // Project Requirements & Terms
  PROJECT_REQUIREMENTS: 'project_requirements',
  TERM_CONDITIONS: 'term_conditions',

  // Payment & Budget
  AMOUNT_USD: 'amount_usd',
  PAYMENT_TYPE: 'payment_type',
  HOURLY_RATE: 'hourly_rate',

  // Timeline
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  EXPECTED_DURATION_DAYS: 'expected_duration_days',

  // Categories
  PRIMARY_CATEGORY: 'primary_category',
  SECONDARY_CATEGORY: 'secondary_category',
  EXPERTISE_LEVEL: 'expertise_level',

  // Technical
  TECH_STACK: 'tech_stack',

  // Business
  BUSINESS_ID: 'business_id',
  WORKER_ID: 'worker_id',
  STATUS: 'status',

  // Metadata
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
};

// Contract Terms and Conditions
export const CONTRACT_TERMS_AND_CONDITIONS = [
  {
    id: 'term-1',
    text: 'Confidentiality: All information exchanged during the project will be treated as strictly confidential.',
  },
  {
    id: 'term-2',
    text: 'Payment Terms: Payments will be made within 15 days of invoice submission upon completion of each approved milestone.',
  },
  {
    id: 'term-3',
    text: 'Intellectual Property: All intellectual property developed during the project will be owned by the client.',
  },
  {
    id: 'term-4',
    text: 'Termination: Either party may terminate the agreement with 30 days written notice.',
  },
  {
    id: 'term-5',
    text: 'Governing Law: This agreement shall be governed by and construed in accordance with the laws of the applicable jurisdiction.',
  },
  {
    id: 'term-6',
    text: 'Force Majeure: Neither party shall be liable for any delay or failure in performance due to causes beyond their reasonable control.',
  },
  {
    id: 'term-7',
    text: 'Amendments: Any amendments to this contract must be made in writing and signed by both parties.',
  },
  {
    id: 'term-8',
    text: 'Entire Agreement: This document constitutes the entire agreement between the parties and supersedes all prior discussions.',
  },
];

// Contract Requirements
export const CONTRACT_REQUIREMENTS = [
  {
    id: 'req-1',
    text: 'Minimum 5 years experience in enterprise-level digital transformation.',
  },
  {
    id: 'req-2',
    text: 'Proven ability to manage complex projects with cross-functional teams.',
  },
  {
    id: 'req-3',
    text: 'Excellent communication and stakeholder management skills.',
  },
  {
    id: 'req-4',
    text: 'Provide a detailed project plan with clear milestones and deliverables.',
  },
];

// Contract Tabs Configuration
export const CONTRACT_TABS = {
  OVERVIEW: {
    label: 'Overview',
    value: 'overview',
    id: 'overview',
  },
  MILESTONES: {
    label: 'Milestones',
    value: 'milestones',
    id: 'milestones',
  },
  MATCHES: {
    label: 'Matches',
    value: 'matches',
    id: 'matches',
  },
  PROPOSALS: {
    label: 'Proposals',
    value: 'submissions',
    id: 'submissions',
  },
};

// Default Contract Data
export const DEFAULT_CONTRACT_DATA = {
  title: 'Strategic Digital Transformation Project',
  description:
    'Innovate Solutions Inc. is seeking a partner to lead a comprehensive digital transformation initiative. This project involves modernizing our legacy systems, implementing new cloud-based infrastructure, and enhancing our customer-facing platforms. The goal is to improve operational efficiency, reduce costs, and deliver a superior customer experience.',
  scope:
    'The project scope includes a full audit of current systems, development of a new enterprise architecture, migration of data to a secure cloud environment, deployment of a new CRM and ERP system, and integration with existing third-party tools. It also covers training for internal teams and post-implementation support for 6 months.',
};

// Milestone Form Default Values
export const MILESTONE_FORM_DEFAULT_VALUES = {
  title: '',
  description: '',
  amount_usd: '',
  due_date: '',
  editingId: null,
};

// Validation Types for Milestone Validation
export const VALIDATION_TYPES = {
  AMOUNT_MISMATCH: 'amount',
  DUPLICATE_DATE: 'duplicate-date',
  SEQUENCE_ORDER: 'sequence-order',
  INVALID_DATE: 'invalid-date',
  PAST_DATE: 'past-date',
};

// Severity Levels for Validation Messages
export const SEVERITY = {
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};

// =============================================================================
// VALIDATION CONSTANTS
// These constants mirror the backend validation rules in:
// internal/gigacore/constants/validation.go
// Keep in sync when backend values change.
// =============================================================================

export const MILESTONE_VALIDATION = {
  // Title length limits
  MAX_TITLE_LENGTH: 500,
  MIN_TITLE_LENGTH: 1,

  // Description length limits
  MAX_DESCRIPTION_LENGTH: 5000,

  // Amount limits (in USD)
  MAX_AMOUNT: 10000000.0, // $10M
  MIN_AMOUNT: 0.0,

  // Batch operation limits
  MAX_PER_BATCH: 50,
  MAX_ID: 1000000, // Frontend IDs above this are considered temporary
};

export const CONTRACT_VALIDATION = {
  // Budget limits (in USD)
  MAX_BUDGET: 50000000.0, // $50M
  MIN_BUDGET: 0.0,

  // Public ID limits
  MAX_PUBLIC_ID_LENGTH: 100,
  MIN_PUBLIC_ID_LENGTH: 1,
};

// Validation error message templates (match backend format)
export const VALIDATION_MESSAGES = {
  TITLE_TOO_LONG: (max) =>
    `Milestone title exceeds maximum length of ${max} characters`,
  TITLE_REQUIRED: 'Milestone title is required',
  DESCRIPTION_TOO_LONG: (max) =>
    `Milestone description exceeds maximum length of ${max} characters`,
  AMOUNT_OUT_OF_RANGE: (min, max) =>
    `Milestone amount must be between $${min.toFixed(2)} and $${max.toFixed(
      2
    )}`,
  BUDGET_OUT_OF_RANGE: (min, max) =>
    `Budget must be between $${min.toFixed(2)} and $${max.toFixed(2)}`,
  INVALID_PUBLIC_ID: 'Invalid contract identifier',
  TOO_MANY_MILESTONES: (max) =>
    `Cannot process more than ${max} milestones in a single request`,
};
